import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import s from './Title.scss';
import { TitleDataHooks } from './constants';
export const Title = ({ title, subTitle, size, dataHook, className, children, ...containerProps }) => {
    return (React.createElement(Box, { className: className, dataHook: dataHook, align: "center", direction: "vertical", ...containerProps },
        title && (React.createElement(Heading, { size: size, className: s.title, dataHook: TitleDataHooks.Title, textAlign: "center" }, title)),
        subTitle && (React.createElement(Text, { className: s.subTitle, dataHook: TitleDataHooks.SubTitle, size: "medium" }, subTitle)),
        children && (React.createElement(Box, { dataHook: TitleDataHooks.Content, direction: "vertical" }, children))));
};
//# sourceMappingURL=Title.js.map